import { AuthNavigatorService } from '@anecdotes/auth-core';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG, ConfigurationFile } from '@anecdotes/configuration-data-access';
import { getLocation } from '@anecdotes/utils';
import { isRedirectToSignIn } from './deprecated-routes-handler.utils';

@Injectable()
export class DeprecatedRoutesHandlerService {
  private readonly appConfig = inject(APP_CONFIG);
  private readonly authNavigator = inject(AuthNavigatorService);

  handleNavigation(): void {
    const trimmedUrl = getLocation().pathname.replace(/^\/+/g, '');
    const config: ConfigurationFile = this.appConfig;
    if (isRedirectToSignIn(trimmedUrl, config)) {
      this.authNavigator.redirectToSignIn();
    }
  }
}
